/**
 * Fetch notifications from arbitium_notifications ring.
 * Blueprint: arbitium_notifications.json
 */

import { fetchRing } from '../core';

export interface NotificationItem {
  _id: string;
  type?: string;
  title: string;
  details?: string;
  source?: string;
  time?: string;
  status: 'unread' | 'read' | 'dismissed';
  _modified?: string;
  [key: string]: unknown;
}

const RING_NOTIFICATIONS = 'arbitium_notifications';

/**
 * Fetches all notifications from the backend ring.
 */
export async function getNotifications(): Promise<NotificationItem[]> {
  const res = await fetchRing<NotificationItem>(RING_NOTIFICATIONS, { all: true });
  return Array.isArray(res.items) ? res.items : [];
}

/**
 * Returns the count of notifications with status === 'unread'.
 */
export function getUnreadCount(items: NotificationItem[]): number {
  return items.filter((n) => n.status === 'unread').length;
}
